import { both, either, pathEq, propEq } from 'ramda';
import { STATES } from '../../constants/states';

// Lifted from the `redux-ui-router` source (v0.6.3). As of this writing, it
// doesn't appear these constants are exported from the library.
// https://github.com/neilff/redux-ui-router/blob/06b943104525fa4b8a14a1d124c27a4caa9e8cac/src/action-types.js
const STATE_CHANGE_ERROR = '@@reduxUiRouter/$stateChangeError';
export const STATE_CHANGE_SUCCESS = '@@reduxUiRouter/$stateChangeSuccess';

// For whatever reason the payload shape differs somewhat between success and
// error actions.
const isFromState = state =>
  either(
    pathEq(['payload', 'fromState', 'name'])(state),
    pathEq(['payload', 'prevState', 'name'])(state)
  );
const isType = propEq('type');

export const isFromRootError = both(
  isFromState(STATES.ROOT),
  isType(STATE_CHANGE_ERROR)
);
